<template>
  <b-modal :active.sync="isModalActive" has-modal-card :width="1280">
    <div class="modal-card compare-modal-card">
      <header class="modal-card-head">
        <h1
          class="is-title-header modal-card-title"
          v-if="summaryDataForCompare && summaryDataForCompare.report_periods"
        >
          Compare {{ summaryDataForCompare.report_periods.r_id_period }} with
          {{ summaryDataForCompare.report_periods.c_id_period }}
        </h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <div class="report-summary" data-cy="report-summary-compare">
              <div class="report-summary-header tile is-parent">
                <h3 class="tile is-3">Reported Items</h3>
                <h3
                  class="tile is-2.5"
                  v-for="(item, index) in summaryDataForCompare[
                    'Reported Items'
                  ]"
                  :key="index"
                >
                  {{
                    item
                      ? item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      : 0
                  }}
                </h3>
              </div>
              <div class="report-summary-body">
                <ul class="tile report-summary-body-title is-parent">
                  <span class="tile is-3">Category</span>

                  <span
                    class="tile is-2.5"
                    v-for="(item, index) in summaryDataForCompare.Category"
                    :key="index"
                  >
                    {{ item }}
                  </span>
                </ul>
                <div
                  v-for="(item, index) in summaryDataForCompare.category_list"
                  :key="index"
                  class="report-summary-body-details"
                >
                  <ul
                    class="tile is-parent"
                    :class="{ 'is-footer': item.footer }"
                  >
                    <span
                      class="tile is-3 report-summary-category-name"
                      v-if="item.main_category"
                      >{{ item.main_category }}</span
                    >
                    <span
                      class="tile is-2.5"
                      v-for="(cat, index2) in summaryDataForCompare.Category"
                      :key="index2"
                    >
                      <b-icon
                        type="is-success"
                        size="is-small"
                        icon="arrow-down"
                        v-if="
                          index2.split(' ').length == 2 &&
                            index2.split(' ')[1] == 'Units' &&
                            item['units_flag'] == 'up'
                        "
                      ></b-icon>
                      <b-icon
                        type="is-danger"
                        icon="arrow-up"
                        size="is-small"
                        v-if="
                          index2.split(' ').length == 2 &&
                            index2.split(' ')[1] == 'Units' &&
                            item['units_flag'] == 'down'
                        "
                      ></b-icon>
                      <b-icon
                        type="is-success"
                        icon="arrow-down"
                        size="is-small"
                        v-if="
                          index2.split(' ').length == 3 &&
                            index2.split(' ')[1] == 'Weights' &&
                            item['weight_flag'] == 'up'
                        "
                      ></b-icon>
                      <b-icon
                        type="is-danger"
                        size="is-small"
                        icon="arrow-up"
                        v-if="
                          index2.split(' ').length == 3 &&
                            index2.split(' ')[1] == 'Weights' &&
                            item['weight_flag'] == 'down'
                        "
                      ></b-icon>
                      <b-icon
                        type="is-success"
                        icon="arrow-down"
                        size="is-small"
                        v-if="
                          index2.split(' ').length == 3 &&
                            index2.split(' ')[1] == 'Fee' &&
                            item['fees_flag'] == 'up'
                        "
                      ></b-icon>
                      <b-icon
                        type="is-danger"
                        size="is-small"
                        icon="arrow-up"
                        v-if="
                          index2.split(' ').length == 3 &&
                            index2.split(' ')[1] == 'Fee' &&
                            item['fees_flag'] == 'down'
                        "
                      ></b-icon>
                      {{
                        item[cat]
                          ? item[cat]
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          : 0
                      }}
                    </span>
                  </ul>
                  <div
                    v-if="item.sub_categories"
                    class="report-summary-subCategories"
                  >
                    <ul
                      v-for="(subItem, subIndex) in item.sub_categories"
                      :key="subIndex"
                      class="tile is-parent"
                    >
                      <span class="tile is-3 report-summary-category-name">{{
                        subItem.name
                      }}</span>
                      <span
                        class="tile is-2.5"
                        v-for="(cat, index2) in summaryDataForCompare.Category"
                        :key="index2"
                      >
                        <b-icon
                          type="is-success"
                          size="is-small"
                          icon="arrow-down"
                          v-if="
                            index2.split(' ').length == 2 &&
                              index2.split(' ')[1] == 'Units' &&
                              subItem['units_flag'] == 'up'
                          "
                        ></b-icon>
                        <b-icon
                          type="is-danger"
                          icon="arrow-up"
                          size="is-small"
                          v-if="
                            index2.split(' ').length == 2 &&
                              index2.split(' ')[1] == 'Units' &&
                              subItem['units_flag'] == 'down'
                          "
                        ></b-icon>
                        <b-icon
                          type="is-success"
                          icon="arrow-down"
                          size="is-small"
                          v-if="
                            index2.split(' ').length == 3 &&
                              index2.split(' ')[1] == 'Weights' &&
                              subItem['weight_flag'] == 'up'
                          "
                        ></b-icon>
                        <b-icon
                          type="is-danger"
                          icon="arrow-up"
                          size="is-small"
                          v-if="
                            index2.split(' ').length == 3 &&
                              index2.split(' ')[1] == 'Weights' &&
                              subItem['weight_flag'] == 'down'
                          "
                        ></b-icon>
                        <b-icon
                          type="is-success"
                          icon="arrow-down"
                          size="is-small"
                          v-if="
                            index2.split(' ').length == 3 &&
                              index2.split(' ')[1] == 'Fee' &&
                              subItem['fees_flag'] == 'up'
                          "
                        ></b-icon>
                        <b-icon
                          type="is-danger"
                          icon="arrow-up"
                          size="is-small"
                          v-if="
                            index2.split(' ').length == 3 &&
                              index2.split(' ')[1] == 'Fee' &&
                              subItem['fees_flag'] == 'down'
                          "
                        ></b-icon>
                        {{
                          subItem[cat]
                            ? subItem[cat]
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : 0
                        }}
                      </span>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="report-summary-header tile is-parent">
                <h3 class="tile is-3">Grand Total</h3>
                <h3
                  class="tile is-2.5"
                  v-for="(item, index) in summaryDataForCompare['Grand Total']"
                  :key="index"
                >
                  {{
                    item
                      ? item.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      : 0
                  }}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button slot="right" type="is-primary" @click="exportReport">
          Export
        </b-button>
        <b-button slot="right" type="is-normal" @click="cancel">
          Back
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import UtilityMixin from "@/mixins/UtilityMixin";
import scopeMixin from "@/mixins/scopeMixin";
import { AdditionalReportingCategories } from "../../constants/ReportManagerConstants";
export default {
  name: "CompareModal",
  mixins: [UtilityMixin, scopeMixin],

  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    data: {},
    summaryDataForCompare: {},
    comparableReport: {}
  },

  data() {
    return {
      compareValue: {},
      isModalActive: false
    };
  },

  methods: {
    cancel() {
      this.disableOKButton = true;
      this.$emit("cancel");
    },
    exportReport() {
      // this.form.execution_urgency = this.urgency;
      this.$emit("export");
    }
  },
  computed: {
    AdditionalReportingCategories: () => AdditionalReportingCategories
  },
  watch: {
    summaryDataForCompare(newValue) {
      // eslint-disable-next-line no-console
      this.compareValue = newValue;
    },
    isActive(newValue) {
      this.isModalActive = newValue;
      // eslint-disable-next-line no-console
      //console.log(this.data.general_information.period);
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
